import { NgClass } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';

import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';
import { EmailMailgunHtmlComponent } from '../email-html/email-mailgun-html.component';
import { EmailTextComponent } from '../email-text/email-text.component';

@Component({
  standalone: true,
  selector: 'email-infobox',
  styleUrls: ['./email-infobox.component.less'],
  template: `<div class="infobox">
    <table class="infobox-table" cellspacing="0" cellpadding="0">
      <tr>
        <td class="infobox-content web-infobox-markup"><mailgun-html [html]="contents" /></td>
      </tr>
    </table>
  </div>`,
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
  imports: [EmailTextComponent, NgClass, EmailMailgunHtmlComponent],
})
export class EmailInfoboxComponent {
  @Input() public contents: WrappedValue<string>;
  @Input() public inline: boolean = false;
}
